<template>
  <nav
    :class="`${
      meta.topbarCollapse() ? ' md:fixed' : ' '
    } flex justify-center gap-3 px-4 bg-white border-gray-200 dark:bg-gray-900 sticky w-full z-50 top-0 left-0 shadow-sm`"
  >
    <div class="flex justify-between w-full">
      <section
        id="logo-section"
        class="cursor-pointer py-5 flex-grow max-w-fit w-10/12 sm:w-10/12 lg:w-4/12 truncate"
      >
        <a
          class="text-lg capitalize dark:text-white font-[700] md:flex flex-row gap-2 items-center justify-start"
          :title="
            getCourseName($route.params.courseName) ??
            $t('labels.generic', { pt: 'Curso', en: 'Course' })
          "
          @click="go.redirectToPage('dashboardStd')"
        >
          <span class="hidden md:block"
            ><i
              class="pi pi-arrow-left"
              style="font-size: 1rem; color: #26577b"
            ></i
          ></span>
          {{
            getCourseName($route.params.courseName) ??
            $t("labels.generic", { pt: "Curso", en: "Course" })
          }}
        </a>
      </section>

      <section
        id="items-logged-section"
        v-if="navItems().length != 0"
        class="hidden max-w-full w-8/12 xl:flex items-end flex-row justify-center mx-4"
      >
        <div class="flex justify-center max-h-fit gap-3 lg:gap-5">
          <ul :class="`flex`" v-for="(item, i) of navItems()" :key="i">
            <router-link
              :class="[
                { active: item.name === routeName },
                {
                  active:
                    item.groupRouteFrom &&
                    $route.meta.groupRouteFrom === item.groupRouteFrom,
                },
              ]"
              :to="{ name: item.name }"
            >
              <li class="pb-2 truncate">
                <Button class="btn-simple" @click="item.command">
                  <v-icon :name="item.icon" class="text-primary-400 mr-2" />

                  {{
                    $t("labels.generic", { pt: item.label, en: item.labelEN })
                  }}
                </Button>
              </li>
            </router-link>
          </ul>
        </div>
      </section>

      <section id="dropdown-section" class="flex justify-end max-w-fit w-2/12">
        <div id="logged-items" class="hidden xl:flex items-center">
          <div class="flex gap-3 items-center w-40">
            <img
              class="rounded-full object-cover w-12 h-12 bg-gray-50"
              :src="
                actualUser?.photoProfile || require('@/assets/images/user.svg')
              "
              @error="imgDefaultError"
              alt="user"
            />
            <p
              class="btn-simple w-32 truncate cursor-pointer capitalize"
              aria-haspopup="true"
              aria-controls="overlay_menu"
              @click="toggleMenu"
              :title="actualUser?.firstName"
            >
              {{ actualUser?.firstName }}
            </p>
          </div>
          <Menu
            id="overlay_menu"
            ref="menu"
            :model="dropdownItems()"
            :popup="true"
          />
        </div>
      </section>

      <section
        id="dropdown-section-mobile"
        class="flex items-center justify-between sm:flex xl:hidden ml-2"
        aria-controls="top-nav"
        aria-expanded="false"
        data-collapse-toggle="top-nav"
      >
        <div class="flex gap-4">
          <div class="flex gap-1 items-center w-8 h-8">
            <img
              class="rounded-full object-cover w-8 h-8 cursor-pointer"
              :src="
                actualUser?.photoProfile || require('@/assets/images/user.svg')
              "
              @error="imgDefaultError"
              alt="user"
              @click="toggleMenu"
            />
          </div>
          <Menu
            id="overlay_menu"
            ref="menu"
            :model="dropdownItems()"
            :popup="true"
          />
        </div>

        <Button
          icon="pi pi-align-right"
          class="btn-simple"
          @click="showSidebar = true"
        />
      </section>
    </div>
  </nav>

  <Sidebar v-model:visible="showSidebar" :baseZIndex="10000" position="right">
    <section v-if="navItems().length != 0">
      <div class="flex flex-col justify-center w-full gap-x-5">
        <ul v-for="(item, i) of navItems()" :key="i">
          <li
            class="bg-h-primary-100 rounded-md border mb-2 active:bg-h-secondary-100"
            @click="handleMobileClick(item.command)"
          >
            <Button
              :label="
                $t('labels.generic', { pt: item.label, en: item.labelEN })
              "
              icon="pi pi-angle-right"
              class="btn-simple p-button-sm"
            />
          </li>
        </ul>
      </div>
    </section>
  </Sidebar>
</template>

<script lang="ts">
import { User } from "@/models/user.model";
import { useCourseStudentStore } from "@/store/course-student";
import { GoToRoute } from "@/utils/go-to.util";
import { RouteMeta } from "@/utils/metas.util";

import { useAuthStore } from "@/store/auth";
import { clearStorage } from "@/utils/user-store.util";
import { defineComponent, h } from "vue";
import { CourseType } from "@/models/courses.model";
export default defineComponent({
  name: "topbar-course",
  computed: {
    go(): GoToRoute {
      return new GoToRoute();
    },
    meta(): RouteMeta {
      return new RouteMeta();
    },
    typeCourse(): CourseType {
      return JSON.parse(localStorage.getItem("course-type") as string);
    },
    classroomId(): string | undefined {
      return localStorage.getItem("classId") ?? undefined;
    },
  },
  props: {
    logo: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      showSidebar: false,
      actualUser: {} as User,
      routeName: null as any,
    };
  },
  mounted() {
    this.actualUser = useAuthStore.getData;
    useCourseStudentStore.setCourseType(this.typeCourse);
  },
  methods: {
    handleMobileClick(command: Function) {
      command();
      this.showSidebar = false;
    },
    dropdownItems(): Array<any> {
      return [
        {
          items: [
            {
              label: this.$t("labels.generic", { pt: "Conta", en: "Account" }),
              name: "editUser",
              icon: "pi pi-users",
              command: () => this.go.redirectToPage("editUser"),
            },
            {
              label: this.$t("labels.generic", {
                pt: "Sobre a plataforma",
                en: "About the platform",
              }),
              name: "about",
              icon: "pi pi-info-circle",
              command: () => this.go.redirectToPage("about"),
            },
            {
              label: this.$t("labels.generic", {
                pt: "Como funciona",
                en: "How it works",
              }),
              name: "howItWorks",
              icon: "pi pi-question-circle",
              command: () => this.go.redirectTo("howItWorks"),
            },
            {
              label: this.$t("labels.generic", { pt: "Sair", en: "Logout" }),
              icon: "pi pi-power-off",
              command: () => this.logoutUser(),
            },
          ],
        },
      ];
    },
    navItems(type?: CourseType): Array<any> {
      const courseType = type ?? this.typeCourse;
      const items = [
        {
          label: "Conteúdo",
          labelEN: "Content",
          name: this.routeDetails(courseType).name,
          icon: "md-playlesson-outlined",
          command: () => this.routeDetails(courseType).command(),
          showFor: [
            CourseType.LINEAR,
            CourseType.INTERACTIVE,
            CourseType.ADAPTATIVE,
          ],
        },
        {
          label: "Atividades",
          labelEN: "Activities",
          name: "studentActivities",
          icon: "bi-list-check",
          command: () => this.go.redirectTo("studentActivities"),
          showFor: this.classroomId
            ? [CourseType.LINEAR, CourseType.INTERACTIVE, CourseType.ADAPTATIVE]
            : [],
          groupRouteFrom: "activities",
        },
        {
          label: "Calendário",
          labelEN: "Calendar",
          name: "calendarStudent",
          icon: "bi-calendar-event",
          command: () => this.go.redirectTo("calendarStudent"),
          showFor: [
            CourseType.LINEAR,
            CourseType.INTERACTIVE,
            CourseType.ADAPTATIVE,
          ],
        },
        {
          label: "Meu desempenho",
          labelEN: "My performance",
          name: this.meta.isPageCourseTraditional()
            ? "courseLinearQuizResults"
            : "courseQuizResults",
          icon: "md-insights",
          command: () =>
            this.go.redirectTo(
              this.meta.isPageCourseTraditional()
                ? "courseLinearQuizResults"
                : "courseQuizResults"
            ),
          showFor: [CourseType.LINEAR, CourseType.ADAPTATIVE],
        },
        {
          label: "Sobre o curso",
          labelEN: "About the course",
          name: this.meta.isPageCourseTraditional()
            ? "courseLinearInformation"
            : "courseInformation",
          icon: "md-menubook",
          command: () =>
            this.go.redirectTo(
              this.meta.isPageCourseTraditional()
                ? "courseLinearInformation"
                : "courseInformation"
            ),
          showFor: [
            CourseType.LINEAR,
            CourseType.INTERACTIVE,
            CourseType.ADAPTATIVE,
          ],
        },
        {
          label: "Fórum",
          labelEN: "Forum",
          name: "forum",
          icon: "md-forum-outlined",
          groupRouteFrom: "forum",
          command: () => this.go.redirectTo("forum"),
          showFor: [
            CourseType.INTERACTIVE,
            CourseType.ADAPTATIVE,
            CourseType.LINEAR,
          ],
        },
      ];

      return items.filter((item) => item.showFor.includes(courseType));
    },
    firstUsername(username?: string): string {
      var arrName = username?.split(" ");
      return arrName ? arrName[0] : "";
    },
    logoutUser(): void {
      clearStorage();
    },
    toggleMenu(event: any): void {
      (this.$refs.menu as any).toggle(event);
    },
    getCourseName(name: any): string {
      const newName = name?.replaceAll("-", " ");
      return newName;
    },
    imgDefaultError(e: any): void {
      e.target.src =
        "https://video-thumb.s3.sa-east-1.amazonaws.com/65197bdbplaceholder.png";
    },
    routeDetails(type: CourseType) {
      const pagesMap = {
        [CourseType.LINEAR]: {
          name: "traditionalCourseContent",
          command: () => this.go.redirectToPage("traditionalCourseContent"),
        },
        [CourseType.INTERACTIVE]: {
          name: "interactiveCourseContent",
          command: () => {
            this.go.redirectToPage("interactiveCourseContent", {
              courseName: this.$route.params.courseName,
              id: this.$route.params.id,
            });
          },
        },
        [CourseType.ADAPTATIVE]: {
          name: "courseContent",
          command: () => this.go.redirectToPage("courseContent"),
        },
      };

      return pagesMap[type] ?? pagesMap[CourseType.ADAPTATIVE];
    },
    getCurrentH5pId(): string | null {
      return useCourseStudentStore.getH5pId;
    },
  },
});
</script>
